import { render, staticRenderFns } from "./updateCustomerInfo.vue?vue&type=template&id=896e1e52&scoped=true&"
import script from "./updateCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./updateCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateCustomerInfo.vue?vue&type=style&index=0&id=896e1e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e1e52",
  null
  
)

export default component.exports